// extracted by mini-css-extract-plugin
export var container = "_mt-0";
export var dotAnimation = "_mt-2";
export var dotsLoading = "_mt-1";